import {
  ToggleButton, ToggleButtonGroup,
} from '@mui/material';
import { useFormikContext } from 'formik';
import _ from 'lodash';

type Props = {
    fieldPath:string,
    orientation: 'vertical' | 'horizontal',
    labels?: string[],
    slot: any
}

const NiveauToggleGroup: React.FC<Props> = (props) => {
  const {
    values, setFieldValue,
  } = useFormikContext<any>();

  const handleChange = (event: any) => {
    setFieldValue(`${props.fieldPath}.data`, [event.target.value]);

    const score = props.slot.scoringFct([event.target.value]);
    setFieldValue(`${props.fieldPath}.score`, score);
  };

  return (<>

    {(props.labels && props.labels.length === 2)
      ? <>
        <ToggleButtonGroup
          orientation={props.orientation}
          exclusive
          value={_.get(values, `${props.fieldPath}.data`)[0]}
          onChange={handleChange}
          disabled={_.get(values, 'isDisabled')}
        >
          <ToggleButton id={props.fieldPath} value='0' color="primary" size="small" sx={{
            fontWeight: 600, textTransform: 'none', fontSize: '13px',
          }}>
            {(props.labels && props.labels[0]) ? props.labels[0] : 'non réalisé'}
          </ToggleButton>
          <ToggleButton id={props.fieldPath} value='1' color="primary" size="small" sx={{
            fontWeight: 600, textTransform: 'none', fontSize: '13px',
          }}>
            {(props.labels && props.labels[1]) ? props.labels[1] : 'réalisé'}
          </ToggleButton>
        </ToggleButtonGroup>
      </>
      : <>
        <ToggleButtonGroup
          orientation={props.orientation}
          exclusive
          value={_.get(values, `${props.fieldPath}.data`)[0]}
          onChange={handleChange}
          disabled={_.get(values, 'isDisabled')}
        >
          <ToggleButton id={props.fieldPath} value='0' color="primary" size="small" sx={{
            fontWeight: 600, textTransform: 'none', fontSize: '13px',
          }}>
            {(props.labels && props.labels[0]) ? props.labels[0] : 'non réalisé'}
          </ToggleButton>
          <ToggleButton id={props.fieldPath} value='0.5' color="primary" size="small" sx={{
            fontWeight: 600, textTransform: 'none', fontSize: '13px',
          }}>
            {(props.labels && props.labels[1]) ? props.labels[1] : 'en cours'}
          </ToggleButton>
          <ToggleButton id={props.fieldPath} value='1' color="primary" size="small" sx={{
            fontWeight: 600, textTransform: 'none', fontSize: '13px',
          }}>
            {(props.labels && props.labels[2]) ? props.labels[2] : 'réalisé'}
          </ToggleButton>
        </ToggleButtonGroup>
      </>
    }
  </>);
};

export default NiveauToggleGroup;
